import React, { useState } from 'react';
import SettingsIcon from '@mui/icons-material/Settings';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import ProjectManagementDialog from './ProjectManagementDialog';

function ProjectSelect(props) {
  const { projects = [], organizationId, activeProject, isProjectSelectionReady = true, onActiveProjectChange, setActiveProject } = props;
  const [managementDialogOpen, setManagementDialogOpen] = useState(false);

  const handleManagementDialogOpen = () => setManagementDialogOpen(true);
  const handleManagementDialogClose = () => setManagementDialogOpen(false);

  const handleActiveProjectChange = (event) => {
    if (event.target.value !== 'manage-projects') {
      onActiveProjectChange(event);
    }
  };

  const selectableProjects = projects.filter(project => project.attributes.name !== 'archive' && project.attributes.is_active !== false);
  const isActiveProjectSelectable = selectableProjects.some(project => project.id === activeProject?.id);

  if (!isProjectSelectionReady) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 56, width: '100%' }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (!activeProject) {
    return (
      <>
        <Button
          onClick={handleManagementDialogOpen}
          startIcon={<SettingsIcon />}
          variant="outlined"
          color="success"
        >
          Manage Projects
        </Button>
        <ProjectManagementDialog
          open={managementDialogOpen}
          onClose={handleManagementDialogClose}
          organizationId={organizationId}
          activeProject={activeProject}
          setActiveProject={setActiveProject}
        />
      </>
    );
  }

  return (
    <>
    <FormControl fullWidth>
      <InputLabel id="select-project-label">Project</InputLabel>
      <Select
        labelId="select-project-label"
        id="select-project"
        value={isActiveProjectSelectable ? activeProject.id : ''}
        label="Project"
        onChange={handleActiveProjectChange}
        displayEmpty
        renderValue={() => activeProject.attributes.name}
      >
        {
          selectableProjects
          .map(
            project => (
              <MenuItem
                value={project.id}
                key={project.id}
              >
                {project.attributes.name}
              </MenuItem>
            ),
          )
        }
        <MenuItem
          value="manage-projects"
          onClick={handleManagementDialogOpen}
          sx={{ color: 'success.main' }
        }>
          <SettingsIcon sx={{ mr: 1, color: 'success.main' }} />
          Manage
        </MenuItem>
      </Select>
    </FormControl>
    <ProjectManagementDialog
      open={managementDialogOpen}
      onClose={handleManagementDialogClose}
      organizationId={organizationId || activeProject.attributes.organization_id}
      activeProject={activeProject}
      setActiveProject={setActiveProject}
    />
</>
  );
}

export default ProjectSelect;
